import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";
import moment from "moment";
import { API_DATE_FORMAT } from "../../../../app_constants.js";

export const SET_LOADING = "introConversion/SET_LOADING";
export const SET_CHART_LOADING = "saga/SET_CHART_LOADING";
export const SET_DATES = "introConversion/SET_DATES";
export const UPDATE_DATES = "introConversion/UPDATE_DATES";
export const CLEAR_DATA = "introConversion/CLEAR_DATA";
export const DISPLAY_ERROR = "introConversion/DISPLAY_ERROR";
export const UPDATE_CUSTOM_RANGE = "introConversion/UPDATE_CUSTOM_RANGE";
export const FETCH_CURRENT_USER = "introConversion/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "introConversion/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "introConversion/FETCH_CURRENT_USER_FAILURE";
export const FETCH_FILTER_DATA = "introConversion/FETCH_FILTER_DATA";
export const FETCH_FILTER_DATA_SUCCESS = "introConversion/FETCH_FILTER_DATA_SUCCESS";
export const FETCH_NEW_FILTER_DATA = "introConversion/FETCH_NEW_FILTER_DATA";
export const FETCH_NEW_FILTER_DATA_SUCCESS = "introConversion/FETCH_NEW_FILTER_DATA_SUCCESS";
export const STATE_FETCH_FILTER_DATA_SUCCESS = "introConversion/STATE_FETCH_FILTER_DATA_SUCCESS";
export const FETCH_OFFERS_DATA_SUCCESS = "introConversion/FETCH_OFFERS_DATA_SUCCESS";
export const UPDATE_FILTERS = "introConversion/UPDATE_FILTERS";
export const UPDATE_FILTERS_SUCCESS = "introConversion/UPDATE_FILTERS_SUCCESS";
export const FETCH_CONVERSION_VALUES = "introConversion/FETCH_CONVERSION_VALUES";
export const FETCH_DATA_AND_FILTERS = "introConversion/FETCH_DATA_AND_FILTERS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  fetchDataAndFilters: createAction(FETCH_DATA_AND_FILTERS),
  fetchNewFilterData: createAction(FETCH_NEW_FILTER_DATA),
  updateDates: createAction(UPDATE_DATES),
  updateFilters: createAction(UPDATE_FILTERS),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(FETCH_FILTER_DATA, getFilterData);
  yield takeLatest(FETCH_DATA_AND_FILTERS, getDataAndFilters);
}

export function* getCurrentUserData({ payload }) {
  yield put({ type: CLEAR_DATA, payload: true });

  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  let calendarEndDate = payload.data.calendarEndDate;
  let endDate;
  let startDate;

  const commonParams = {
    organization_id: organization_id,
    short_url: short_url
  };

  if (payload.updateFilters) {
    yield put({ type: SET_CHART_LOADING, payload: true });

    startDate = yield select((state) => state.introConversion.selectedRequestDates.startDate);
    endDate = yield select((state) => state.introConversion.selectedRequestDates.endDate);

    let selectedFilters = yield select((state) => state.introConversion.selectedFilters);
    let i;
    let allSagas = [];
    for (i = 0; i < selectedFilters.length; i++) {
      allSagas.push(getOffersData(commonParams, startDate, endDate, selectedFilters[i].id));
    }
    try {
      yield all(allSagas);
      yield put({ type: SET_CHART_LOADING, payload: false });
    } catch (error) {
      console.error(error);
    }
  } else {
    yield put({ type: SET_CHART_LOADING, payload: true });

    startDate = moment(calendarEndDate).startOf("month").format(API_DATE_FORMAT);
    endDate = calendarEndDate;
    yield put({
      type: FETCH_CURRENT_USER_SUCCESS,
      payload: { ...payload.data, organization_id, short_url }
    });
    yield put({ type: SET_DATES, payload: { startDate: startDate, endDate: endDate } });

    const getFilterDataSaga = getFilterData(commonParams, startDate, endDate);
    yield getFilterDataSaga;
    try {
      let selectedFilters = yield select((state) => state.introConversion.selectedFilters);
      let i;
      let allSagas = [];

      if (selectedFilters.length === 0) {
        yield put({
          type: DISPLAY_ERROR
        });
      } else {
        for (i = 0; i < selectedFilters.length; i++) {
          allSagas.push(getOffersData(commonParams, startDate, endDate, selectedFilters[i].id));
        }
        try {
          yield all(allSagas);
          yield put({ type: SET_CHART_LOADING, payload: false });

          yield put({ type: SET_LOADING, payload: false });
        } catch (error) {
          console.error(error);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
}

export function* getDataAndFilters(data) {
  const commonParams = {
    organization_id: data.payload.data.organization_id,
    short_url: data.payload.data.short_url
  };

  let { startDate, endDate } = yield select((state) => state.introConversion.selectedRequestDates);

  const getFilterDataSaga = getFilterData(commonParams, startDate, endDate, true);
  yield getFilterDataSaga;
  try {
    yield put({ type: SET_CHART_LOADING, payload: true });

    let selectedFilters = yield select((state) => state.introConversion.selectedFilters);
    let i;
    let allSagas = [];
    if (selectedFilters.length === 0) {
      yield put({
        type: DISPLAY_ERROR
      });
    } else {
      yield put({ type: CLEAR_DATA, payload: true });
      for (i = 0; i < selectedFilters.length; i++) {
        allSagas.push(getOffersData(commonParams, startDate, endDate, selectedFilters[i].id));
      }
      try {
        yield all(allSagas);
        yield put({ type: SET_CHART_LOADING, payload: false });
      } catch (error) {
        console.error(error);
      }
    }
  } catch (error) {
    console.error(error);
  }
}

export function* getFilterData(commonParams, start_date, end_date, usePrevSelectedFilters = false) {
  try {
    const tableDataResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/retention/intro_conversion/get_filters",
      {
        params: { ...commonParams, start_date, end_date }
      }
    );
    yield put({
      type: FETCH_FILTER_DATA_SUCCESS,
      payload: { data: tableDataResponse.data, usePrevSelectedFilters }
    });
  } catch (error) {
    console.error(error);
  }
}

export function* getOffersData(commonParams, start_date, end_date, id) {
  try {
    const tableDataResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/retention/intro_conversion/get_offer_values",
      { params: { ...commonParams, start_date, end_date, id } }
    );
    yield put({ type: FETCH_OFFERS_DATA_SUCCESS, payload: tableDataResponse.data });
  } catch (error) {
    console.error(error);
  }
}
